import type { LayerType } from '../data/v1'

export const FOCUSABLE_LAYER_TYPES = new Set<LayerType>(['text', 'image', 'backdrop', 'shape', 'substack', 'content'])
export const RESIZABLE_LAYER_TYPES = new Set<LayerType>(['shape', 'image'])
